// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.button-m {
  background-color: #ff736e;
  font-family: IBM Plex Mono;
  font-weight: 700;
  text-transform: uppercase;
  padding: 12px 18px;
  border-radius: 4px;
  border: solid 2px #121212;
  box-shadow: 4px 4px #121212;
  transition: transform 50ms,
  box-shadow 50ms;
}
.button-m:hover{
  transform: translate(2px, 2px);
  box-shadow: 2px 2px #121212;
}

.button-m-container button {
  background-color: #8fddd3;
  font-family: IBM Plex Mono;
  font-weight: 700;
  text-transform: uppercase;
  padding: 12px 18px;
  border-radius: 4px;
  border: solid 2px #121212;
  box-shadow: 4px 4px #121212;
  transition: transform 50ms,
  box-shadow 50ms;
  pointer-events: none;
  cursor: default;
}
.button-s-container button:hover{
  transform: translate(2px, 2px);
  box-shadow: 2px 2px #121212;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B;iBACe;AACjB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B;iBACe;EACf,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.button-m {\n  background-color: #ff736e;\n  font-family: IBM Plex Mono;\n  font-weight: 700;\n  text-transform: uppercase;\n  padding: 12px 18px;\n  border-radius: 4px;\n  border: solid 2px #121212;\n  box-shadow: 4px 4px #121212;\n  transition: transform 50ms,\n  box-shadow 50ms;\n}\n.button-m:hover{\n  transform: translate(2px, 2px);\n  box-shadow: 2px 2px #121212;\n}\n\n.button-m-container button {\n  background-color: #8fddd3;\n  font-family: IBM Plex Mono;\n  font-weight: 700;\n  text-transform: uppercase;\n  padding: 12px 18px;\n  border-radius: 4px;\n  border: solid 2px #121212;\n  box-shadow: 4px 4px #121212;\n  transition: transform 50ms,\n  box-shadow 50ms;\n  pointer-events: none;\n  cursor: default;\n}\n.button-s-container button:hover{\n  transform: translate(2px, 2px);\n  box-shadow: 2px 2px #121212;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
